import React, { useEffect, useState } from "react";
import { setAuthentication } from "./commons/Auth/auth";
import { Success, Error } from "./commons/Messages/Messages";
import { useTranslation } from "react-i18next";
import "./ExchangePage.css";

export default function ExchangePage() {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");

    if (!code) {
      setLoading(false);
      Error("Missing code parameter");
      return;
    }

    // Capture the domain the user came from (auth server / portal)
    if (document.referrer) {
      try {
        const referrerUrl = new URL(document.referrer);
        localStorage.setItem("sourceDomain", referrerUrl.origin);
      } catch (e) {}
    }

    const url = process.env.REACT_APP_AUTH_URL;

    fetch(`${url}/auth/exchange`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code })
    })
      .then(res => res.json())
      .then(res => {
        if (res.statusCode == 400) {
          alert(res.message);
        }
        const role = res?.user?.role;
        const historySring = role === 2 || role === 1 ? "/user" : role === 4 ? "/admin" : "/client";

        setAuthentication(res.user, res.accessToken, res.refreshToken);
        Success(res.user?.successMessage || "Logged in successfully");
        i18n.changeLanguage(res?.user?.language || "en");

        window.location.href = `${location.origin}${historySring}`;
      })
      .catch(err => {
        Error("Something went wrong during login.");
      })
      .finally(() => setLoading(false));
  }, []);

  if (!loading) return null;

  return (
    <div className="exchange-page" role="status" aria-live="polite" aria-busy="true">
      <div className="exchange-page__spinner" aria-hidden="true"></div>
      <h1 className="exchange-page__title">{t("processingLogin") || "Processing login..."}</h1>
      <p className="exchange-page__subtitle">{t("pleaseWait") || "Please wait a moment..."}</p>
    </div>
  );
}
